import Vue from 'vue';
import ExplanationBox from '@/components/pages/CreateStudyPage/explanationBox';

Vue.component('explanation-box', ExplanationBox);
